/* Kropsterapi Hanne Brask — minimal JS */
(function () {
  'use strict';

  // Mobile nav toggle
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      const isOpen = nav.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('nav-open', isOpen);
    });
    // Close menu only when clicking destination links (not dropdown carets or parent-with-children labels)
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        // Don't close if the link belongs to a parent that has children on mobile —
        // user might want to navigate, which is fine. Closing is OK after navigation.
        nav.classList.remove('is-open');
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Dropdown menu toggles (mobile accordion + desktop touch fallback)
  const carets = document.querySelectorAll('[data-nav-caret]');
  carets.forEach(function (caret) {
    caret.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const item = caret.closest('[data-nav-item]');
      if (!item) return;
      const isOpen = item.classList.toggle('is-open');
      caret.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      // Close sibling open items at the same level
      if (isOpen && item.parentElement) {
        Array.prototype.forEach.call(item.parentElement.children, function (sib) {
          if (sib !== item && sib.classList && sib.classList.contains('is-open')) {
            sib.classList.remove('is-open');
            const sibCaret = sib.querySelector(':scope > [data-nav-caret]');
            if (sibCaret) sibCaret.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });

  // Close dropdowns when clicking outside (desktop)
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) {
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (item) {
        item.classList.remove('is-open');
        const c = item.querySelector(':scope > [data-nav-caret]');
        if (c) c.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Sticky mobile CTA – hide on scroll up, show on scroll down
  const stickyCta = document.querySelector('[data-sticky-cta]');
  if (stickyCta) {
    let lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      const y = window.scrollY;
      if (y < 200) { stickyCta.classList.add('is-hidden'); }
      else if (y > lastY) { stickyCta.classList.remove('is-hidden'); }
      else { stickyCta.classList.remove('is-hidden'); }
      lastY = y;
    }, { passive: true });
  }

  // Reviews slider — bruger native CSS scroll-snap (mest pålideligt)
  const slider = document.querySelector('[data-reviews-slider]');
  if (slider) {
    const track = slider.querySelector('[data-reviews-track]');
    const slides = Array.from(track.children);
    const dotsEl = slider.querySelector('[data-reviews-dots]');
    const prevBtn = slider.querySelector('[data-reviews-prev]');
    const nextBtn = slider.querySelector('[data-reviews-next]');
    let timer;
    let isHover = false;

    function currentIndex() {
      const sw = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 16);
      return Math.round(track.scrollLeft / sw);
    }

    function goTo(i) {
      const sw = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 16);
      const max = slides.length - 1;
      const idx = Math.max(0, Math.min(i, max));
      track.scrollTo({ left: idx * sw, behavior: 'smooth' });
    }

    function next() {
      const i = currentIndex();
      goTo(i >= slides.length - 1 ? 0 : i + 1);
    }
    function prev() {
      const i = currentIndex();
      goTo(i <= 0 ? slides.length - 1 : i - 1);
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      slides.forEach(function (_, i) {
        const b = document.createElement('button');
        b.className = 'reviews-slider__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Gå til anmeldelse ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); resetTimer(); });
        dotsEl.appendChild(b);
      });
    }

    function updateDots() {
      const i = currentIndex();
      dotsEl.querySelectorAll('button').forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
      });
    }

    function startTimer() { if (!isHover) timer = setInterval(next, 6000); }
    function stopTimer() { clearInterval(timer); }
    function resetTimer() { stopTimer(); startTimer(); }

    nextBtn.addEventListener('click', function () { next(); resetTimer(); });
    prevBtn.addEventListener('click', function () { prev(); resetTimer(); });
    slider.addEventListener('mouseenter', function () { isHover = true; stopTimer(); });
    slider.addEventListener('mouseleave', function () { isHover = false; startTimer(); });
    track.addEventListener('scroll', updateDots, { passive: true });

    buildDots();
    startTimer();
  }

  // Scroll-reveal
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  // Smooth-scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const id = a.getAttribute('href');
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        document.querySelector(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
